import React from 'react';

const Saturation = ({ className }) => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23" cy="23" r="23" fill="#232328" />
            <path className="ac-s" d="M18.1345 22.7732L22.7604 16L27.5239 22.5691C29.4281 25.195 28.7763 28.884 26.0992 30.7156C24.1028 32.0816 21.4536 32.0507 19.4965 30.629C16.9923 28.8099 16.3888 25.3292 18.1345 22.7732Z" stroke="white" strokeLinecap="round" />
            <path className="ac-f" d="M28 27.0006C28 29.7618 25.7614 32.0002 23 32.0002C20.2386 32.0002 17.5 29.7615 17.5 27.0002C17.5 27.0002 20 29.0002 23 27.0002C26 25 28 27.0006 28 27.0006Z" fill="white" />
        </svg>
    )
}

export default Saturation;